import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionsService } from '../services/collections.service';

@Component({
  selector: 'app-add-to-collection-modal',
  templateUrl: './add-to-collection-modal.component.html',
  styleUrls: ['./add-to-collection-modal.component.scss'],
})
export class AddToCollectionModalComponent implements OnInit {
  visible = false;
  editCollectionModalVisible = false;
  selectedCollection?: string;
  @Output() close = new EventEmitter<void>();
  @Input() page: {
    pageUid: string;
    versionUid: string;
  };

  constructor(public collectionsService: CollectionsService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.visible = true;
    }, 0);
  }

  handleConfirm(): void {
    this.collectionsService
      .addPage(this.page, this.selectedCollection)
      .then(() => this.close.emit());
  }
}
